"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _material = require("@mui/material");
var _TabContext = require("../contexts/TabContext");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @typedef AccountPageProps
 * @type {import("../index").AccountPageProps}
 */

/** @param {AccountPageProps} props */
function Tabs(_ref) {
  var app = _ref.app,
    auth = _ref.auth;
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    tab = _useContext.tab,
    setTab = _useContext.setTab;
  var companyadmin = auth.user.companyadmin;
  var tabList = Object.keys(_TabContext.tabComponents).filter(function (key) {
    if (!companyadmin && key === 'charge') return false;
    return true;
  }).map(function (key) {
    return {
      key: key,
      label: _TabContext.tabLabels[key],
      icon: _TabContext.tabIcons[key],
      app: _TabContext.tabApps[key]
    };
  });
  console.log('tabList: >=>', tabList);
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: "Account-tabs"
  }, tabList.filter(function (tabItem) {
    if (!tabItem.app || tabItem.app === 'all') return true;
    return tabItem.app === app;
  }).map(function (tabItem) {
    return /*#__PURE__*/_react["default"].createElement(_material.Button, {
      key: tabItem.key,
      className: "Account-tabs-item",
      onClick: function onClick() {
        return setTab(tabItem.key);
      },
      "data-selected": tab === tabItem.key
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: tabItem.icon
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "Account-tabs-item-label"
    }, tabItem.label));
  }));
}
var _default = Tabs;
exports["default"] = _default;